"use client";

// Bloc affiché à la place du bouton d'achat quand une formation est en mode
// attente (course.showWaitingMode), sur les 21 fiches qui le rendent.
//
// Avant, ce composant faisait exactement l'inverse de ce qu'on attend d'une
// liste d'attente : le bouton était DÉSACTIVÉ pour un membre connecté (il ne
// pouvait donc rien signaler), et un visiteur était renvoyé vers /signup, ce
// qui imposait de créer un compte pour dire « prévenez-moi ». Une fonction
// toggleSubscribe visait par ailleurs /api/course/post/subscribe, une route
// qui n'a jamais existé.
//
// Il délègue à CourseWaitlist : un clic pour les membres, un champ e-mail pour
// les visiteurs, et une alerte à l'équipe dans les deux cas.
//
// Les fiches rendent ce composant à deux endroits, distingués par `stack` :
// dans le bandeau, à la place du bouton d'achat, et dans la colonne de droite.
// Le bandeau reçoit la version au trait — le bloc encadré y écrasait la
// hiérarchie de la page —, la colonne garde le bloc complet.

import CourseWaitlist from "@/components/Course/CourseWaitlist/CourseWaitlist";

export default function WaitCourse(props) {
    return (
        <div className="w-full">
            <CourseWaitlist
                courseSlug={props.course?.slug}
                courseName={props.course?.name}
                variant={props.stack ? "card" : "inline"}
            />
        </div>
    );
}
